import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, AfterViewInit, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-form-field-dropdown-multi-option-icon-v2',
    templateUrl: './form-field-dropdown-multi-option-icon-v2.component.html',
    styleUrls: ['./form-field-dropdown-multi-option-icon-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDropdownMultiOptionIconV2Component implements OnInit, AfterViewInit, AfterContentChecked {

  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;

  focusedOption: number = -1;
  dropIsClosed = true;
  selectedOpt: any;
  sortAsc = true;
  checkboxAllStatus = false;
  disabled: boolean = false;
  data: any = [];
  clickedInsideComponent: boolean = false;
  selectedItems = [];
  selectAllText = "all";
  dropdownArrayValue = [];
  filteredSuggestion = "";
  filterMinLength = 2;

  @ViewChild('dropdown',{static: true, read: ElementRef}) dropdown: ElementRef;
  @ViewChild('dropdownselect',{static: true, read: ElementRef}) dropdownselect: ElementRef;
  @ViewChild('dropIcon',{static: true, read: ElementRef}) dropIcon: ElementRef;  
  @ViewChild('options',{static: true, read: ElementRef}) options: ElementRef;
  @ViewChild('dropdownouter',{static: true, read: ElementRef}) dropdownouter: ElementRef;
  @ViewChild('sortIcon',{static: true, read: ElementRef}) sortIcon: ElementRef; 
  @ViewChild('typableinput',{static: true, read: ElementRef}) typableinput: ElementRef;   
  
  constructor(private renderer: Renderer2) {
  }

  isClickInsideComponent(element, classname) {
    if (element && element.className && element.className.split(' ').indexOf(classname)>=0) return true;
    return element.parentNode && this.isClickInsideComponent(element.parentNode, classname);
  }

  ngOnInit() {    
    this.disabled = this.configData.disabled;
    this.filterMinLength = this.configData["filterMinLength"] | 2;
    if(this.configData.disabled){
      this.frmGroup.get(this.configData.name)['required'] = false;
      this.configData.required = false;
    }else{
      this.data = JSON.parse(JSON.stringify(this.configData));
    }

    this.renderer.listen('window', 'click',(e:Event)=>{  
      this.clickedInsideComponent = this.isClickInsideComponent(e.target,'dhl-dropdown');
      if(!this.clickedInsideComponent || (e.target !== this.dropdown.nativeElement && e.target !== this.dropdownselect.nativeElement && 
          e.target!==this.options.nativeElement && e.target !== this.dropIcon.nativeElement &&
          e.target!==this.dropdownouter.nativeElement && (this.sortIcon && e.target !== this.sortIcon.nativeElement))){
            this.focusout();
       }
     });
  }

  toggleDisable(bool){
    this.disabled = bool;
  }

  ngAfterViewInit() {
    if(Object.keys(this.configData.defaultValue).length > 0){
      this.selectedOption(this.configData.defaultValue, true);
    }else if(this.frmGroup.get(this.configData.name).value.length > 0){
      this.selectedOption(this.frmGroup.get(this.configData.name).value, true);
    }


    this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
        if(this.frmGroup.get(this.configData.name).value == undefined){
          this.dropdown.nativeElement.classList.remove('filled');
        }else{
          this.frmGroup.get(this.configData.name).markAsDirty();
        }
    });
  }
  
  ngAfterContentChecked() {
    if(!this.dropIsClosed){
      this.positionDrop();
    }
  }

  toggleDrop(target){
    if(target.classList.value.indexOf('sort-icon') == -1 || 
      (target.classList.value.indexOf('sort-icon') > -1 && this.dropIsClosed)){
      this.dropIsClosed = !this.dropIsClosed;
      if(this.dropIsClosed){
        this.dropdown.nativeElement.classList.remove('focus');
        this.dropIcon.nativeElement.classList.replace('open', 'closed');
        if(this.configData.sortable){
          this.sortIcon.nativeElement.classList.replace('default', 'filled');
        }
      }else{
        this.dropdown.nativeElement.classList.add('focus');
        this.dropIcon.nativeElement.classList.replace('closed', 'open');
        this.typableinput.nativeElement.focus();
      }
      if(this.selectedItems.length == 0){
        this.dropdown.nativeElement.classList.remove('filled');
      }
    }
  }

  sortOptions(){
    if(this.data.options.length > 0) {
      if(this.sortAsc){
        this.data.options.sort((a, b) => a.displayValue < b.displayValue ? -1 : a.displayValue > b.displayValue ? 1 : 0);
      }else{
        this.data.options.sort((a, b) => a.displayValue > b.displayValue ? -1 : a.displayValue < b.displayValue ? 1 : 0);
      }
    }
    this.sortAsc = !this.sortAsc;
  }

  positionDrop(){
    const {left, top} = this.options.nativeElement.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elOffsetTop = top + scrollTop;
    let elHeight = this.options.nativeElement.offsetHeight;
    let heightOfDropdown = this.dropdownouter.nativeElement.offsetHeight;
    let mainContentAreaPaddingBottom = 24; //document.getElementsByClassName('main-content-area').style.paddingBottom;
    if ((window.innerHeight - mainContentAreaPaddingBottom) < elOffsetTop + elHeight) {
      this.options.nativeElement.classList.add('ulta');
      this.options.nativeElement.style.top = (7 - elHeight) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    }else{
      this.options.nativeElement.classList.remove('ulta');
      this.options.nativeElement.style.top = (heightOfDropdown - 7) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    }
  }

  focusout(forced?:boolean){    
    if(!this.clickedInsideComponent || forced){
      this.dropIsClosed = true;
      this.dropdown.nativeElement.classList.remove('focus');
      if(this.dropIcon){
        this.dropIcon.nativeElement.classList.replace('open', 'closed');
      }
    }
    if(this.configData.sortable){
      if(this.selectedOpt !== undefined){
        this.sortIcon.nativeElement.classList.replace('focused', 'default');
      }else{
        this.sortIcon.nativeElement.classList.replace('focused', 'filled');
      }
    }
    if(forced){
      this.frmGroup.get(this.configData.name).markAsTouched();
    }
    this.dropdown.nativeElement.classList.remove('tab-focus');
    this.typableinput.nativeElement.value = "";
    this.filteredSuggestion = "";
    let dropoptions = this.options.nativeElement.querySelectorAll(".drop-option");
    for(let i=0;i<dropoptions.length; i++) {
      dropoptions[i].classList.replace("no-show", "show");
    }
  }

  focusin(){
    if(this.dropdown && this.options && this.options.nativeElement.classList.value.indexOf('hide') > -1){
      this.dropdown.nativeElement.classList.add('tab-focus');
    }
  }

  selectedOption(selOpt, selectDefault){
    if(selectDefault && Array.isArray(selOpt)){
      this.selectedItems = [];
      if(selOpt.length == 1 && selOpt[0] == this.selectAllText){
        this.selectedOption(this.selectAllText, false);
      }else{
        selOpt.forEach(value => {
          this.data.options.forEach(option => {
            if(option.value == value){
              option["selected"] = true;  
              this.selectedItems.push(option);
            }
          });
        });
      }
      this.frmGroup.get(this.configData.name).setValue(selOpt.toString());
      this.dropdown.nativeElement.classList.add('filled');
    }else{
      this.dropdownArrayValue.splice(0, this.dropdownArrayValue.length);
      if(typeof selOpt == 'string' && selOpt.toUpperCase() == this.selectAllText.toUpperCase()){
        this.selectedItems = [];
        this.data.options.forEach(option => {
          option["selected"] = true;
          this.selectedItems.push(option);
          this.dropdownArrayValue.push(option.value);
        });
      }else{
        selOpt['selected'] = true;
        this.selectedItems = [];
        this.data.options.forEach(option => {
          if(option["selected"]){
            this.selectedItems.push(option);
            this.dropdownArrayValue.push(option.value);
          }
        });
      }
      this.frmGroup.get(this.configData.name).setValue(this.dropdownArrayValue.toString());
      this.dropdown.nativeElement.classList.add('filled');
      this.typableinput.nativeElement.value = "";
    }
  }

  @HostListener("window:keydown", ['$event'])
  onKeyDown(event:KeyboardEvent) {
    if(this.dropdown.nativeElement.classList.value.indexOf('tab-focus') > -1
      || this.dropdown.nativeElement.classList.value.indexOf('focus') > -1){
        const optionsOuter = this.options.nativeElement;
        const options = optionsOuter.children[0].children;
        if(event.key == 'ArrowDown' && this.options.nativeElement.classList.value.indexOf('hide') > -1){
          this.toggleDrop(event.target);
        }else if(event.key == 'ArrowDown'){
          if(this.focusedOption > -1 && options.length > 0 && this.focusedOption < options.length){
            options[this.focusedOption].classList.remove('hover')
          }
          this.focusedOption += 1;
          if(this.focusedOption >= options.length){
            this.focusedOption = options.length - 1 ;
          }
          if(this.focusedOption < options.length){
            options[this.focusedOption].classList.add('hover');
            options[this.focusedOption].scrollIntoView({behavior: "smooth", inline: "nearest"});
          }
        }
        if(event.key == 'ArrowUp' && this.options.nativeElement.classList.value.indexOf('hide') == -1){          
          if(this.focusedOption > 0){
            options[this.focusedOption].classList.remove('hover')
          }
          this.focusedOption -= 1;
          if(this.focusedOption <= 0){
            this.focusedOption = 0 ;
          }
          if(this.focusedOption < options.length && this.focusedOption > -1){
            options[this.focusedOption].classList.add('hover');
            options[this.focusedOption].scrollIntoView({behavior: "smooth", inline: "nearest"});
          }
        }
        if(event.key == 'Enter' && this.options.nativeElement.classList.value.indexOf('hide') == -1){
          this.selectedOption(this.data.options[this.focusedOption], false);
        }
        if(event.key == 'Tab'){
          this.focusout(true);
        }
        if(event.key == 'ArrowRight' && this.typableinput.nativeElement.value.length > this.filterMinLength){
          let filteredDropoptions = this.options.nativeElement.querySelectorAll(".drop-option.show");
          this.selectedOption(this.data.options[filteredDropoptions[0].id], false);
        }
      }
  }

  removeItem(item){
    this.dropdownArrayValue.splice(0, this.dropdownArrayValue.length);
    this.selectedItems.forEach(function(currentItem, idx){
      if(currentItem.value == item.value){
        item["selected"] = false;
        this.selectedItems.splice(idx, 1);
      }else{
        this.dropdownArrayValue.push(currentItem.value);
      }
    }.bind(this));
    this.frmGroup.get(this.configData.name).setValue(this.dropdownArrayValue.toString());
  }

  typableKeyup(event: Event){
    if(this.dropIsClosed){
      this.dropIsClosed = false;
      this.dropdown.nativeElement.classList.add('focus');
      this.dropIcon.nativeElement.classList.replace('closed', 'open');
      this.typableinput.nativeElement.focus();
    }
    let dropoptions = this.options.nativeElement.querySelectorAll(".drop-option");
    let dropoptionsTxt = this.options.nativeElement.querySelectorAll(".drop-option .texts");
    if(this.typableinput.nativeElement.value.length > this.filterMinLength){
      let filter = this.typableinput.nativeElement.value;
      let count = 0;
      for(let i=0;i<dropoptionsTxt.length; i++) {
        let txtValue = dropoptionsTxt[i].textContent || dropoptionsTxt[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter.toUpperCase()) > -1) {
          dropoptions[i].classList.replace("no-show", "show");
          let filteredDropoptions = this.options.nativeElement.querySelectorAll(".drop-option.show");
          this.filteredSuggestion = filteredDropoptions[0].innerText;
        } else {
          count++;
          dropoptions[i].classList.replace("show", "no-show");
          // if(count == dropoptions.length){
          //   this.nomatch.nativeElement.classList.replace("no-show", "show");
          // }else{
          //   this.nomatch.nativeElement.classList.replace("show", "no-show");
          // }
        }
      }
    }else{
      // this.nomatch.nativeElement.classList.replace("show", "no-show");
      this.filteredSuggestion = "";
      for(let i=0;i<dropoptionsTxt.length; i++) {
        dropoptions[i].classList.replace("no-show", "show");
      }
    }
    this.positionDrop();
  }

}
